/**
 * Shared sanitizer config for editor-generated HTML (Tiptap output).
 * Used by index-page cards + detail pages so rich-text fields render
 * consistently and safely.
 *
 * Usage:
 *   import DOMPurify from "dompurify";
 *   import { RICH_TEXT_SANITIZE } from "@/lib/rich-text";
 *   <div className="upr-rich-teaser"
 *        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html, RICH_TEXT_SANITIZE) }} />
 */
export const RICH_TEXT_SANITIZE = {
  ALLOWED_TAGS: ["p", "br", "strong", "em", "b", "i", "u", "a", "h1", "h2", "h3", "ul", "ol", "li", "blockquote", "hr"],
  ALLOWED_ATTR: ["href", "target", "rel"],
  FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form"],
  FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "onfocus"],
  // KEEP_CONTENT defaults to true — do NOT flip it. Setting false strips the
  // inner text of allowed tags like <p>, which hides all editor content.
};
